var _circle, _circle2, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#F2DFBA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#2A282E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3366_286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#2A282E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3366_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3459 24.1819C20.721 24.1819 22.0651 23.7741 23.2084 23.0102C24.3517 22.2463 25.2428 21.1605 25.769 19.8901C26.2952 18.6198 26.4329 17.2219 26.1646 15.8733C25.8964 14.5247 25.2342 13.2859 24.2619 12.3136C23.2896 11.3413 22.0509 10.6792 20.7023 10.4109C19.3536 10.1427 17.9558 10.2804 16.6854 10.8066C15.4151 11.3328 14.3293 12.2238 13.5653 13.3671C12.8014 14.5104 12.3937 15.8546 12.3937 17.2296C12.3937 19.0735 13.1261 20.8418 14.4299 22.1456C15.7337 23.4494 17.5021 24.1819 19.3459 24.1819ZM19.3459 26.1683C15.0368 26.1683 6.43457 28.83 6.43457 34.1137V38.0864H32.2573V34.1137C32.2573 28.83 23.6551 26.1683 19.3459 26.1683Z",
    fill: "#93969B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.16bf9c9d91d865ca60852eb9e9ff8e35.svg";
export { ForwardRef as ReactComponent };